import type { BrandConfig } from '../types'
import placeholderImage from './assets/placeholder.svg'
import logoImage from './assets/logo.svg'
import testimonial1 from './assets/testimonial-1.svg'
import testimonial2 from './assets/testimonial-2.svg'
import testimonial3 from './assets/testimonial-3.svg'

const config: BrandConfig = {
  appName: 'MindCore',
  brandName: 'MindCore',
  description: 'Sistema de agendamento para terapeutas',
  logo: {
    src: logoImage,
    alt: 'Logótipo da marca',
  },
  heroImage: {
    src: placeholderImage,
    alt: 'Consultório de terapia acolhedor',
  },
  serviceImage: {
    src: placeholderImage,
    alt: 'Sessão de terapia em andamento',
  },
  testimonials: [
    {
      name: 'Dr.ª Elisa Barros',
      role: 'Psicóloga Clínica',
      text: 'O MindCore garante a confidencialidade e a facilidade de agendamento que os meus pacientes necessitam.',
      image: testimonial1,
    },
    {
      name: 'Anónimo',
      role: 'Paciente',
      text: 'Poder marcar as minhas sessões online, de forma discreta, foi um fator decisivo para procurar ajuda. Obrigado.',
      image: testimonial2,
    },
    {
      name: 'Clínica Mente Sã',
      role: 'Direção',
      text: 'A plataforma ajudou-nos a organizar as agendas dos nossos terapeutas e a melhorar a comunicação com os pacientes.',
      image: testimonial3,
    },
  ],
}

export default config
